import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Dropdown, MenuItem, Label, FormGroup, FormControl, Form, ControlLabel } from 'react-bootstrap';
import { reduxForm, change, formValueSelector, Field, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';


import { InputField, DisabledInputsField, ControlledInputField, ControllabledStateInputField } from '../Common/inputField';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection';
import { ROOT_URL, ROOT_API_URL, BUSINESS_USERS_URL, companyCodeTitle, isOLG } from '../../actions/root_url';


const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';

const verifyStatus = [{
  value: false,
  label: 'In Progress',
}, {
  value: true,
  label: 'Verified',
}];
const priceLevelOptions = [{
  value: 1,
  label: 'Level 1'
}, {
  value: 2,
  label: 'Level 2'
}, {
  value: 3,
  label: 'Level 3'
}, {
  value: 4,
  label: 'Level 4'
}, {
  value: 5,
  label: 'Level 5'
}];

const retailerStatus = [{
  label: 'YES',
  value: true,
}, {
  label: 'NO',
  value: false,
}];

const businessTypes = [{
  label: 'C-Corp',
  value: 'C-Corp',
}, {
  label: 'S-Corp',
  value: 'S-Corp',
}, {
  label: 'LLC',
  value: 'LLC',
}, {
  label: 'Sole Proprietor',
  value: 'Sole Proprietor',
}];

const propTypes = {
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const BusinessUserEditModal = ({ handleSubmit, cancel, confirm, user, paymentTermOptions, swDisable }) => (
  <Panel>
    <form className="form-horizontal" method="get" action="#" >
      <Grid style={{ width: '100%' }}>
        <Row>
          <Col sm={3}>
            <label><Translate value="business_name" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="full_name" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="phone_number" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="email" /></label>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'business_name'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'full_name'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'phone_number'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'email'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
        </Row>


        <Row>
          <Col sm={3}>
            <label><Translate value="street" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="suite" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="city" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="state" /></label>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'street'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'suit_unit'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'city'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'state'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
        </Row>


        <Row>
          <Col sm={3}>
            <label><Translate value="zipcode" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="verified" /></label>
          </Col>
          <Col sm={3}>
            {isOLG && <label><Translate value="price_level" /></label>}
          </Col>
          <Col sm={3}>
            {isOLG && <label><Translate value="payment_term" /></label>}
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'zipcode'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'is_process'} component={Selection} options={verifyStatus} disabled={true} />
              </div>
            </div>
          </Col>
          <Col sm={3}>
            {isOLG && <div className="form-group">
              <div className="col-xs-12">
                <Field name={'PriceLevel'} component={Selection} options={priceLevelOptions} disabled={swDisable}/>
              </div>
            </div>}
          </Col>
          <Col sm={3}>
            {isOLG && <div className="form-group">
              <div className="col-xs-12">
                <Field name={'PaymentTerm_id'} component={Selection} options={paymentTermOptions} disabled={swDisable}/>
              </div>
            </div>}
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <label><Translate value="business_type" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="ein" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="ssn" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="is_retailer" /></label>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                {/* <Field name={'business_type'} component={InputField} /> */}
                <Field name={'business_type'} component={Selection} options={businessTypes} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'ein'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'ssn'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'is_retailer'} component={Selection} options={retailerStatus} disabled={swDisable}/>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <label><Translate value="resale_no" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="dun_brad_no" /></label>
          </Col>
          <Col sm={3}>
            <label><Translate value="year_in_business" /></label>
          </Col>
          <Col sm={3}>
            {/* <label><Translate value="is_retailer" /></label> */}
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'resale_no'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'dun_brad_no'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <div className="col-xs-12">
                <Field name={'business_year'} component={InputField} disabled={swDisable}/>
              </div>
            </div>
          </Col>
          <Col sm={3}>
            {/* <div className="form-group">
              <div className="col-xs-12">
                <Field name={'is_retailer'} component={InputField} />
              </div>
            </div> */}
            {
              isHF && 
              <div>
                {
                  (user.file1 !== null && user.file1 !== '') &&
                  <Button 
                    bsStyle="success"
                    href={user.file1}
                  >
                    <em className="fa fa-download"/>  Document 1
                  </Button> 
                }
              </div>
            }
            {
              isHF && 
              <div>    
                {
                  ((user.file2 != null) && (user.file2 != "")) &&
                  <Button 
                    bsStyle="success"
                    href={user.file2}
                  >
                    <em className="fa fa-download"/>  Document 2
                  </Button>
                }
              </div>
            }
            {
              isHF && 
              <div>
                {
                  ((user.file3 != null) && (user.file3 != "")) &&
                  <Button 
                    bsStyle="success"
                    href={user.file3}
                  >
                    <em className="fa fa-download"/>  Document 3
                  </Button>
                }
                </div>
            }
            {
              isHF && 
              <div>
                {
                  ((user.file4 != null) && (user.file4 != "")) &&
                  <Button 
                    bsStyle="success"
                    href={user.file4}
                  >
                    <em className="fa fa-download"/>  Document 4
                  </Button>
                }
                </div>
            }
            {
              isHF && 
              <div>
                {
                  ((user.file5 != null) && (user.file5 != "")) &&
                  <Button 
                    bsStyle="success"
                    href={user.file5}
                  >
                    <em className="fa fa-download"/>  Document 5
                  </Button>
                }
              </div>
          }
            
          </Col>
        </Row>


        <Row className="centerStyle">
        {
            !swDisable &&
          <Button bsStyle="primary" style={{ marginRight: '5px', width: '90px' }} onClick={cancel}>
            <Translate value="cancel" />
          </Button>
          }
          {
            !swDisable &&
          <Button bsStyle="success" style={{ width: '90px' }} onClick={handleSubmit(confirm)}>
            <Translate value="submit" />
          </Button>
          }
        </Row>
      </Grid>
    </form>
  </Panel>
);

function mapStateToProps(state) {
  const initialValues = state.settings.selectedBusinessUser;
  if (isOLG) {
    initialValues.PriceLevel = initialValues.PriceLevel || 5;
  }
  const paymentTermOptions = (state.paymentTerms.all || []).map(item => ({
    value: item.PaymentTerm_id, 
    label: item.Name
  }));
  return {
    initialValues,
    paymentTermOptions,
  };
}

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Email can not be empty';
  }
  if (!values.business_name) {
    errors.business_name = 'Business name can not be empty';
  }
  if (!values.full_name) {
    errors.full_name = 'Name can not be empty';
  }
  if (!values.phone_number) {
    errors.phone_number = 'Phone number can not be empty';
  }
  if (!values.street) {
    errors.street = 'Street can not be empty';
  }
  if (!values.city) {
    errors.city = 'City can not be empty';
  }
  if (!values.state) {
    errors.state = 'State can not be empty';
  }
  if (!values.zipcode) {
    errors.zipcode = 'Zipcode can not be empty';
  }
  return errors;
};

BusinessUserEditModal.propTypes = propTypes;

const businessUserEditModal = reduxForm({
  form: 'userManagement/businessUserEdit',
  destroyOnUnmount: true,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
  validate,
})(BusinessUserEditModal);

export default connect(mapStateToProps)(businessUserEditModal);




// WEBPACK FOOTER //
// ./master/jsx/components/Settings/businessUserEditModal.jsx